<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md8>
				<v-layout row wrap>
					<v-flex xs6 md12>
						<ValidationProvider name="name" rules="required" v-slot="{ errors }">
							<v-text-field :label="$t('Name')" type="text" v-model="item.name" data-vv-name="name" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs4 md4>
						<ValidationProvider name="price" rules="required" v-slot="{ errors }">
							<v-text-field :label="$t('Price')" type="number" v-model="item.price" data-vv-name="price" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs4 md4>
						<ValidationProvider name="bonus" rules="required" v-slot="{ errors }">
							<v-text-field :label="$t('label.bonus')" type="number" v-model="item.bonus" data-vv-name="bonus" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs4 md4>
						<ValidationProvider name="credit" rules="required" v-slot="{ errors }">
							<v-text-field :label="$t('label.credit')" type="number" v-model="item.credit" data-vv-name="credit" :error-messages="errors"></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md12>
						<v-textarea :label="$t('Description')" v-model="item.description"></v-textarea>
					</v-flex>
					<v-flex xs12 md12>
						<v-checkbox v-model="item.is_private" label="Is private?"></v-checkbox>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md4>
				<v-card>
					<v-card-title primary-title>
						<h3>{{ $t("label.image") }}</h3>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<app-media-library v-model="item.image"></app-media-library>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	export default {
		props: ["value"],
		computed: {
			item: {
				get() {
					return this.value;
				},
				set(value) {
					this.$emit("input", value);
				},
			},
		},
	};
</script>